/**
 * src/lib/constants/departments.js — Canonical department slugs + i18n labels.
 *
 * Mirrors the `departments` table in Supabase (single source of truth).
 * Slugs here are lowercase versions of departments.name.
 * Display layer translates via departmentLabel(slug, locale).
 */

export const DEPARTMENTS = ['design', 'scanner', 'workshop', 'installation', 'procurement', 'admin', 'sales'];

const LABELS = {
  design:       { en: 'Design',       es: 'Diseño' },
  scanner:      { en: 'Scanner',      es: 'Escáner' },
  workshop:     { en: 'Workshop',     es: 'Taller' },
  installation: { en: 'Installation', es: 'Instalación' },
  procurement:  { en: 'Procurement',  es: 'Compras' },
  admin:        { en: 'Admin',        es: 'Administración' },
  sales:        { en: 'Sales',        es: 'Ventas' },
};

const LEGACY_TO_SLUG = {
  // English
  'design':         'design',
  'scanner':        'scanner',
  'workshop':       'workshop',
  'production':     'workshop',     // legacy alias
  'installation':   'installation',
  'procurement':    'procurement',
  'admin':          'admin',
  'sales':          'sales',
  // Spanish
  'diseño':         'design',
  'diseno':         'design',
  'escáner':        'scanner',
  'escaner':        'scanner',
  'taller':         'workshop',
  'produccion':     'workshop',     // legacy alias
  'producción':     'workshop',
  'instalacion':    'installation',
  'instalación':    'installation',
  'compras':        'procurement',
  'administracion': 'admin',
  'administración': 'admin',
  'ventas':         'sales',
};

export function normalizeDepartment(input) {
  if (!input) return null;
  const key = String(input).trim().toLowerCase();
  return LEGACY_TO_SLUG[key] || (DEPARTMENTS.includes(key) ? key : null);
}

export function departmentLabel(slug, locale = 'en') {
  const norm = normalizeDepartment(slug);
  if (!norm) return '';
  const entry = LABELS[norm];
  return entry ? (entry[locale] || entry.en) : slug;
}
